import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils';

interface IProps {
  isOpen: boolean;
  closeCallback: () => void;
  confirmCallback: () => void;
}
export const TurnOffFaceRecognitionModal: React.FC<IProps> = ({
  isOpen,
  closeCallback,
  confirmCallback
}) => {
  const closeModal = () => {
    closeCallback();
  };

  const turnOffFaceRecognition = () => {
    confirmCallback();
    closeCallback();
  };

  return (
    <Modal centered isOpen={isOpen} wrapClassName="modal-dark" size="lg">
      <ModalHeader toggle={closeModal}>Confirmation</ModalHeader>
      <ModalBody>{getTranslationKey('faceRecognition.infoBox')}</ModalBody>
      <ModalFooter>
        <Button
          data-cy="TurnOffFaceRecognitionSaveButton"
          size="md"
          onClick={closeModal}
          className="btn btn-primary"
        >
          {getTranslationKey('faceRecognition.cancelButton')}
        </Button>
        <Button
          data-cy="TurnOffFaceRecognitionSaveButton"
          size="md"
          color="success"
          onClick={turnOffFaceRecognition}
          className="btn btn-primary"
        >
          {getTranslationKey('faceRecognition.disableButton')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
